module.exports = __webpack_public_path__ + "img/Flag_of_Belize.447d508b.svg";